import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Send } from 'lucide-react';

export default function AdminMessages() {
  const [threads, setThreads] = useState([]);
  const [selected, setSelected] = useState(null);
  const [thread, setThread] = useState([]);
  const [body, setBody] = useState('');

  useEffect(() => { load(); }, []);
  const load = async () => { const r = await api.get('/messages'); setThreads(r.data); };
  const openThread = async (uid) => { setSelected(uid); const r = await api.get(`/messages/${uid}`); setThread(r.data); };
  const send = async () => {
    if (!body || !selected) return;
    await api.post('/messages', { to_user_id: selected, body });
    setBody('');
    openThread(selected);
    load();
  };

  return (
    <div className="space-y-6" data-testid="admin-messages">
      <div>
        <div className="label-mini text-[#00C8FF]">1:1</div>
        <h1 className="font-display font-black text-4xl mt-1">Messages</h1>
      </div>
      <div className="grid grid-cols-3 gap-4 h-[60vh]">
        <div className="regen-card-elevated overflow-y-auto p-3 space-y-1">
          {threads.length === 0 && <div className="text-muted-foreground text-sm p-4">No messages yet</div>}
          {threads.map(t => (
            <button key={t.user.id} onClick={() => openThread(t.user.id)} data-testid={`thread-${t.user.id}`}
              className={`w-full text-left p-3 rounded-lg transition ${selected === t.user.id ? 'bg-[#00C8FF]/10' : 'hover:bg-[var(--c-film)]'}`}>
              <div className="flex items-center justify-between">
                <div className="font-medium text-sm">{t.user.name}</div>
                {t.unread > 0 && <span className="pill bg-[#00C8FF] text-[#081726] text-[10px]">{t.unread}</span>}
              </div>
              <div className="text-xs text-muted-foreground truncate mt-0.5">{t.last_message?.body}</div>
            </button>
          ))}
        </div>
        <div className="col-span-2 regen-card-elevated flex flex-col">
          {!selected ? <div className="flex-1 flex items-center justify-center text-muted-foreground">Select a conversation</div> : (
            <>
              <div className="flex-1 overflow-y-auto p-5 space-y-3">
                {thread.map(m => (
                  <div key={m.id} className={`flex ${m.from_user_id === selected ? 'justify-start' : 'justify-end'}`}>
                    <div className={`max-w-[60%] p-3 rounded-2xl text-sm ${m.from_user_id === selected ? 'bg-[var(--c-film)]' : 'bg-[#00C8FF] text-[#081726]'}`}>{m.body}</div>
                  </div>
                ))}
              </div>
              <div className="border-t border-[var(--c-hair)] p-3 flex gap-2">
                <Input value={body} onChange={e => setBody(e.target.value)} placeholder="Type a message…" data-testid="admin-msg-input" className="bg-transparent border-[var(--c-hair)]" onKeyDown={e => e.key === 'Enter' && send()} />
                <Button onClick={send} data-testid="admin-msg-send" className="bg-[#00C8FF] text-[#081726]"><Send className="w-4 h-4" /></Button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
